
<template>
    <Section class="grid--summary">
        <header class="flex-center edit-toggle">
            <h2>{{ currentArea.name }}</h2>
        </header>

        <Tabs>
            <Tab name="Key Points" :selected="true" ref="keypoints" :setMaxHeight="keypointsMaxContent">
                <component
                    :is="wysiwygComponent"
                    v-if="isAdmin"
                    :hideToggle="true"
                    :theContent="currentArea.keypoints"
                    @destroyed="editingKeypoints = false"
                >
                    <template v-slot="{ content }">
                        <transition name="fade-in" mode="out-in">
                            <Alert type="success" :hideTitle="true" v-if="success.keypoints">
                                {{ success.keypoints }}
                            </Alert>
                        </transition>

                        <transition name="fade-in" mode="out-in">
                            <Alert type="error" :hideTitle="true" v-if="error.keypoints">
                                {{ error.keypoints }}
                            </Alert>
                        </transition>

                        <footer class="tab__actions">
                            <Button display="link" style="font-size: 1rem; margin-left: auto;" v-if="isAdmin && !content.editing" @click="toggleEdit(content, 'Keypoints')">Edit Overview</Button>
                            <Button display="link" style="font-size: 1rem; margin-left: auto;" v-if="isAdmin && content.editing" @click="cancelEdit(content, 'Keypoints')">Cancel</Button>

                            <Button
                                v-if="isAdmin && content.editing"
                                display="primary"
                                :class="[
                                    'btn--sm',
                                    { 'btn--loading' : loading },
                                    { 'btn--success' : success.keypoints}
                                ]"
                                @click="updateContent('keypoints', content)">
                                {{ keypointsBtnLabel }} <Spinner v-if="loading" />
                            </Button>
                        </footer>
                    </template>
                </component>

                <Content class="wysiwyg wysiwyg__main" v-if="showStaticContent">
                    <div v-html="currentArea.keypoints" />
                </Content>
            </Tab>

            <Tab name="Overview" ref="description" :setMaxHeight="!descriptionMaxContent">
                <component
                    :is="wysiwygComponent"
                    v-if="isAdmin"
                    :hideToggle="true"
                    :theContent="currentArea.description"
                    @destroyed="editingDescription = false"
                >
                    <template v-slot="{ content }">
                        <transition name="fade-in" mode="out-in">
                            <Alert type="success" :hideTitle="true" v-if="success.description">
                                {{ success.description }}
                            </Alert>
                        </transition>

                        <transition name="fade-in" mode="out-in">
                            <Alert type="error" :hideTitle="true" v-if="error.description">
                                {{ error.description }}
                            </Alert>
                        </transition>

                        <footer class="tab__actions">
                            <Button display="link" style="font-size: 1rem; margin-left: auto;" v-if="isAdmin && !content.editing" @click="toggleEdit(content, 'Description')">Edit Overview</Button>
                            <Button display="link" style="font-size: 1rem; margin-left: auto;" v-if="isAdmin && content.editing" @click="cancelEdit(content, 'Description')">Cancel</Button>

                            <Button
                                v-if="isAdmin && content.editing"
                                display="primary"
                                :class="[
                                    'btn--sm',
                                    { 'btn--loading' : loading },
                                    { 'btn--success' : success.description}
                                ]"
                                @click="updateContent('description', content)">
                                {{ overviewBtnLabel }} <Spinner v-if="loading" />
                            </Button>
                        </footer>
                    </template>
                </component>

                <Content class="wysiwyg wysiwyg__main" v-if="showStaticContent">
                    <div v-html="currentArea.description" />
                </Content>
            </Tab>
        </Tabs>
    </Section>
</template>

<script>
import addWysiwygComponent from '@/mixins/addWysiwygComponent.js'
import { toTitleCase } from '@/helpers'
import { mapActions } from 'vuex'

export default {
    props: {
        currentArea: { type: Object, required: true }
    },

    mixins: [addWysiwygComponent],

    data() {
        return {
            loading: false,
            success: {
                keypoints: null,
                description: null,
            },
            error: {
                keypoints: null,
                description: null,
            },
            editingKeypoints: false,
            editingDescription: false
        }
    },

    computed: {
        overviewBtnLabel () {
            if (this.loading) return 'Saving Overview'
            return 'Update Overview'
        },

        keypointsBtnLabel () {
            if (this.loading) return 'Saving Key Points'
            return 'Update Key Points'
        },

        keypointsMaxContent () {
            return this.editingKeypoints
        },

        descriptionMaxContent () {
            return this.editingDescription
        },
    },

    mounted () {
        if (this.keypointsExceedsMaxLength) this.snipContent('keypoints')
        if (this.overviewExceedsMaxLength) this.snipContent('description')
    },

    methods: {
        ...mapActions('Resources', ['updateArea']),

        updateContent (tab, content) {
            this.loading = true
            this.error[tab] = null

            const data = {
                ...this.currentArea,
                [tab]: content.body,
                status: 'visible'
            }

            this.updateArea(data)
                .then(() => this.setSuccess(tab, content))
                .catch(err => { this.error[tab] = err.message || err })
                .finally(() => {
                    this.loading = false
                })
        },

        toggleEdit (content, type) {
            content.toggleEdit()
            this[`editing${type}`] = !this[`editing${type}`]
        },

        cancelEdit (content, type) {
            content.cancelEdit()
            this[`editing${type}`] = !this[`editing${type}`]
        },

        setSuccess (val, content) {
            this[`editing${toTitleCase(val)}`] = false

            let type = toTitleCase(val)
            if (val === 'keypoints') type = 'Key Points'

            this.success[val] = `Updated ${type} Successfully`

             setTimeout(() => {
                this.success[val] = null

                // Toggle the WysiwygEditor components "editing" value to false...
                content.toggleEdit(false)
            }, 5000)
        }
    }
}
</script>

